(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-with-image"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.evfaq__item'));
      if (this.items.length === 0) return;

      this.singleOpen = this.dataset.singleOpen === 'true';
      this.speed = parseInt(this.dataset.speed || '320', 10);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach((item) => {
        const summary = item.querySelector('.evfaq__q');
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (item.open) {
            this.close(item);
          } else {
            this.open(item);
          }
        });
      });
    }

    open(item) {
      if (this.singleOpen) {
        this.items.forEach((other) => {
          if (other !== item && other.open) this.close(other);
        });
      }

      // Opening is simple: <details> reveals the panel at 1fr and CSS eases it.
      item.classList.add('is-collapsing');
      item.open = true;
      if (this.reduced) {
        item.classList.remove('is-collapsing');
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => item.classList.remove('is-collapsing'));
      });
    }

    close(item) {
      if (this.reduced) {
        item.open = false;
        return;
      }

      // Animate to 0fr first, then actually close so the content stays
      // rendered for the duration of the transition.
      item.classList.add('is-collapsing');
      clearTimeout(item._closeTimer);
      item._closeTimer = setTimeout(() => {
        item.open = false;
        item.classList.remove('is-collapsing');
      }, this.speed);
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('track-seventeen')) {
  const SRC = 'https://www.17track.net/externalcall.js';

  // Loaded once per page and shared by every instance of the section.
  function load17Track() {
    if (window.__yqt17Promise) return window.__yqt17Promise;

    window.__yqt17Promise = new Promise((resolve, reject) => {
      if (window.YQV5) return resolve(window.YQV5);

      const script = document.createElement('script');
      script.src = SRC;
      script.async = true;

      script.onload = () => {
        // YQV5 can attach a tick or two after load in some builds.
        let tries = 0;
        (function poll() {
          if (window.YQV5) return resolve(window.YQV5);
          if (++tries > 60) return reject(new Error('17TRACK did not initialise'));
          setTimeout(poll, 100);
        })();
      };

      script.onerror = () => {
        window.__yqt17Promise = null; // allow a retry
        reject(new Error('17TRACK script could not be loaded'));
      };

      document.head.appendChild(script);
    });

    return window.__yqt17Promise;
  }

  class TrackSeventeen extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.yqt__form');
      this.input = this.querySelector('.yqt__input');
      this.button = this.querySelector('.yqt__btn');
      this.message = this.querySelector('.yqt__message');
      if (!this.form || !this.input) return;

      this.containerId = this.dataset.container;
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);

      // Prefill and auto-track from a URL parameter, e.g. /pages/track?nums=ABC123
      const param = this.dataset.urlParam;
      if (param) {
        const value = new URLSearchParams(window.location.search).get(param);
        if (value) {
          this.input.value = value.trim();
          this.track(this.input.value);
        }
      }
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    onSubmit(event) {
      event.preventDefault();
      const num = this.input.value.trim();

      if (!num) {
        this.say(this.dataset.error || 'Enter your tracking number.', 'error');
        this.input.focus();
        return;
      }

      this.track(num);
    }

    say(text, state) {
      if (!this.message) return;
      if (!text) {
        this.message.hidden = true;
        return;
      }
      this.message.textContent = text;
      this.message.hidden = false;
      if (state) {
        this.message.setAttribute('data-state', state);
      } else {
        this.message.removeAttribute('data-state');
      }
    }

    track(num) {
      this.say(this.dataset.loading || 'Looking up your parcel…');
      if (this.button) this.button.setAttribute('aria-busy', 'true');

      load17Track()
        .then((YQV5) => {
          YQV5.trackSingle({
            YQ_ContainerId: this.containerId,
            YQ_Height: parseInt(this.dataset.height || '560', 10),
            YQ_Fc: this.dataset.carrier || '0',
            YQ_Lang: this.dataset.lang || 'en',
            YQ_Num: num
          });
          this.say('');
        })
        .catch(() => {
          this.say('Tracking is temporarily unavailable. Please try again shortly.', 'error');
        })
        .finally(() => {
          if (this.button) this.button.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('track-seventeen', TrackSeventeen);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-craftsmanship"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ev-story-section')) {
  class EvStorySection extends HTMLElement {
    connectedCallback() {
      const targets = Array.from(this.querySelectorAll('[data-ev-reveal]'));
      if (targets.length === 0) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (el) => el.classList.add('ev-in-view');

      // No observer support, reduced motion, or theme editor: show immediately.
      if (reduced || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        targets.forEach(show);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            show(entry.target);
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      targets.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('ev-story-section', EvStorySection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ev-trust-bar')) {
  class EvTrustBar extends HTMLElement {
    connectedCallback() {
      const targets = Array.from(this.querySelectorAll('[data-ev-reveal]'));
      if (targets.length === 0) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (el) => el.classList.add('ev-in-view');

      if (reduced || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        targets.forEach(show);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            show(entry.target);
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -30px 0px' }
      );

      targets.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('ev-trust-bar', EvTrustBar);
}

  } catch(e) { console.error(e); }
})();
})();
